  export const imagesData1 = [
        {
            imageSrc: "photos/map.webp",
            altText: "Mapa symbolizująca miasto Zielona Góra",
            text: "Obsługujemy lokalizacje w promieniu 25km od Zielonej Góry.",
            width: 512,
            height: 512
          },
        //   {
        //     imageSrc: "photos/online.png",
        //     altText: "Proces oline",
        //     text: "Cały proces online, tylko u nas!"
        //     ,
        //     width: 512,
        //     height: 512
        //   },
          {
            imageSrc: "photos/steering-wheel.webp",
            altText: "Pinezka wskazująca Zieloną Górę",
            text: "Nasz dostawca stawi się prosto pod wskazanym miejscem!"
            ,
            width: 512,
            height: 512
          }
    ]


     export const imagesData2 = [
        {
            imageSrc: "photos/piach.webp",
            altText: "Kupka piasku",
            text: "Piasek zasypowy",
         
          },
          {
            imageSrc: "photos/ziemia do podnoszenia terenu.webp",
            altText: "Kupka ziemi",
            text: "Ziemia na podniesienie terenu"
            ,
          },
           {
            imageSrc: "photos/kruszywo.webp",
            altText: "Kupka kruszywa",
            text: "Kruszywa drogowe"
            ,
          },
           {
            imageSrc: "photos/ziemia.webp",
            altText: "Pinezka wskazująca Zieloną Górę",
            text: "Ziemia ogrodowa"
            ,
          },
        //   {
        //     imageSrc: "photos/gift-voucher.webp",
        //     altText: "Zdjęcie bonu podarunkowego",
        //     text: "Zbieraj punkty i wymieniaj na gotówkę!"
        //     ,
        //     width: "512",
        //     height: "512"
        //   }
    ]